import {
  educationParallelTextRepresentation,
  SCHOOL_PARALLEL_GROUPS,
} from 'entities/education-class';
import type { EducationClass } from 'services/api';
import type { AppGroupedSelectOption } from 'shared/UI/UIKit/Select';

const parallelGlobalOrder = new Map(
  SCHOOL_PARALLEL_GROUPS.flatMap((g) => [...g.parallels]).map((p, index) => [p, index]),
);

export const sortEducationClassesBySchoolOrder = (classes: EducationClass[]) =>
  [...classes].sort((a, b) => {
    const oa = parallelGlobalOrder.get(a.parallel) ?? 0;
    const ob = parallelGlobalOrder.get(b.parallel) ?? 0;
    if (oa !== ob) {
      return oa - ob;
    }
    return a.litera.localeCompare(b.litera, 'ru');
  });

export const getClassOptionsBySchoolGroup = (
  educationClasses: EducationClass[],
): AppGroupedSelectOption[] =>
  SCHOOL_PARALLEL_GROUPS.map((group) => {
    const inGroup = educationClasses.filter((c) => group.parallels.includes(c.parallel));
    const sorted = sortEducationClassesBySchoolOrder(inGroup);
    return {
      label: group.label,
      options: sorted.map((ec) => ({
        value: ec.id,
        label: `${educationParallelTextRepresentation[ec.parallel]}${ec.litera}`,
      })),
    };
  }).filter((g) => g.options.length > 0);
